<template>
  <div class="mv-bg-main">
    <el-card >
      <div slot="header" class="clearfix">
        <span>查询条件</span>
      </div>
      <el-form :inline="true" ref="searchForm" :model="form" class="demo-form-inline ">
        <el-form-item label="客户名称" prop="custId">
          <el-select :filter-method="filterPinYinMethod"  @clear="clearMatch" v-model="form.custId"  clearable filterable placeholder="请选择客户名称">
            <el-option :label="item.custName" :value="item.custId" v-for="(item, $index) in form.cusData" :key="$index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="调价状态" prop="state">
          <el-select v-model="form.state"  clearable filterable placeholder="请选择调价状态">
            <el-option label="已过期" value="3" ></el-option>
            <el-option label="生效中" value="2" ></el-option>
            <el-option label="待生效" value="1" ></el-option>
            <el-option label="已取消" value="0" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日账单时间" prop="date">
          <el-date-picker
            v-model="form.date"
            :editable = "editable"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            >
          </el-date-picker>
        </el-form-item>
        <el-form-item class="float-r">
          <el-button size="small" @click="onReset('searchForm')">重置</el-button>
          <el-button type="primary" size="small" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="m-top">
      <div slot="header" class="clearfix">
        <span class="card-title">查询结果</span>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          label="调价批次"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span class="link" @click="detail(scope.$index, scope.row)">{{ scope.row.custProdAdjustPriceId }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="调价时间"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="客户名称"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.custName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="调价服务"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.serviceName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="调整前价格(元)"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.beforeUnitPrice }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="调整后价格(元)"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.afterUnitPrice }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="调价后计价策略"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.strategyName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="调价生效时间"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.effectiveTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="调价状态"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.adjustedStatus | adjustedStatusSwitch}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作人"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.modifier }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="备注"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.remark }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="100">
          <template slot-scope="scope">
            <!-- <el-button size="mini"  @click="detail(scope.$index, scope.row)">详情</el-button> -->
            <el-button size="mini" :disabled="scope.row.adjustedStatus === '1' ? false : true" @click="clear(scope.$index, scope.row)">取消</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt center"
        background
        @size-change="handleSizeChange"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="page"
        layout="total, sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-card>
    <el-dialog  title="客户产品调价详情"  width="988px" center :modal-append-to-body='false' :visible.sync="detailDialog">
      <el-form :model="customerInfo"   >
        <el-row>
        <el-col :span="12">
          <el-form-item label="客户名称:"    :label-width="formLabelWidth">
            <el-input style="width: 217px;" disabled  v-model="customerInfo.custName" ></el-input>
            <!-- <span>{{customerInfo.custName}}</span> -->
          </el-form-item>
          <el-form-item label="产品名称:"   :label-width="formLabelWidth">
            <el-input style="width: 217px;" disabled  v-model="customerInfo.custProdName" ></el-input>
            <!-- <span>{{customerInfo.custProdName}}</span> -->
          </el-form-item>
          <el-form-item label="客户账户:"   :label-width="formLabelWidth">
            <el-input style="width: 217px;" disabled  v-model="customerInfo.custActName" ></el-input>
            <!-- <span>{{customerInfo.custActName}}</span> -->
          </el-form-item>
          <el-form-item label="调价时间:"   :label-width="formLabelWidth">
            <el-input style="width: 217px;" disabled  v-model="customerInfo.createTime" ></el-input>
            <!-- <span>{{customerInfo.createTime}}</span> -->
          </el-form-item>
          <el-form-item label="生效时间:"   :label-width="formLabelWidth">
            <el-input style="width: 217px;" disabled  v-model="customerInfo.effectiveTime" ></el-input>
            <!-- <span>{{customerInfo.effectiveTime  }}</span> -->
          </el-form-item>
          <el-form-item label="调价状态:"   :label-width="formLabelWidth">
            <span>{{customerInfo.adjustedStatus | adjustedStatusSwitch }}</span>
          </el-form-item>
          <el-form-item label="调价后计价策略:" :label-width="formLabelWidth">
            <el-input style="width: 217px;" disabled  v-model="customerInfo.strategyName" ></el-input>
            <!-- <span>{{customerInfo.strategyName}}</span> -->
          </el-form-item>
          <el-form-item label="调价后规则:" :label-width="formLabelWidth">
            <valuation-template1 :ruleData="ruleData" :dataDetail="dataDetail" v-if="single"></valuation-template1>
            <valuation-template2 :amountData="amountData" :dataDetail="dataDetail" v-if="amountDosage"></valuation-template2>
            <valuation-template3 :packetData="packetData" :dataDetail="dataDetail" v-if="packetTime"></valuation-template3>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="原产品价格(元):"   :label-width="formLabelWidth">
            <el-input style="width: 217px;" disabled  v-model="customerInfo.beforeUnitPrice" ></el-input>
            <!-- <span>{{customerInfo.beforeUnitPrice}}</span> -->
          </el-form-item>
          <el-form-item label="调价后价格(元):"   :label-width="formLabelWidth">
            <el-input style="width: 217px;" disabled  v-model="customerInfo.afterUnitPrice" ></el-input>
            <!-- <span>{{customerInfo.afterUnitPrice}}</span> -->
          </el-form-item>
          <el-form-item label="操作人:"   :label-width="formLabelWidth">
            <el-input style="width: 217px;" disabled  v-model="customerInfo.modifier" ></el-input>
            <!-- <span>{{customerInfo.modifier}}</span> -->
          </el-form-item>
          <el-form-item label="调价备注:" :label-width="formLabelWidth">
            <el-input type="textarea" style="width: 217px;" maxlength="150" disabled v-model="customerInfo.desc"></el-input>
          </el-form-item>
          <el-form-item label="调价凭证:" :label-width="formLabelWidth">
            <div v-if="imgSrc.length">
              <img class="img" :src="item.fileUrl" alt="" v-for="(item, $index) in imgSrc" :key="$index"  />
            </div>
          </el-form-item>
        </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
.img {
  width: 112px;
  height: 112px;
  margin-right: 10px;
}
</style>
<script>
import valuationTemplate1 from './singleRule.vue'
import valuationTemplate2 from './amountRule.vue'
import valuationTemplate3 from './packetRule.vue'
export default {
  name: 'productPricingManagement',
  data () {
    return {
      form: {
        cusData: [],
        custId: '',
        state: '',
        date: ''
      },
      custCopeSimpleInfoList: [], // 客户拼音复制列表
      tooltip: true,
      single: false,
      amountDosage: false,
      packetTime: false,
      ruleData: {
        outputParamsPricings: [
          // { 模板数据
          //   outputParamsPricing: {
          //     pricing: [
          //       {
          //         type: '1', // 等于大于那列
          //         key: 'timeout',
          //         value: '3',
          //         timeout: '3' // 这个字段需拆分成上面的key value
          //       }
          //     ],
          //     price: '22'
          //   }
          // }
        ]
      }, // 规则数据 单次计价
      amountData: { // 调用 金额计价 规则
        outputParamsPricings: {
          section: [
            // {
            //   start: '1',
            //   end: '2',
            //   price: '10'
            // }
          ],
          outputParamsPricing: [
            // {
            //   pricing: [
            //     {
            //       type: '1',
            //       key: 'returnCode',
            //       value: '1',
            //       returnCode: '1' // 这个字段需拆分成上面的key value
            //     },
            //     {
            //       type: '5',
            //       key: 'serviceId',
            //       value: '4',
            //       serviceId: '4' // 这个字段需拆分成上面的key value
            //     }
            //   ]
            // }
          ]
        }
      },
      packetData: { // 包时段规则
        outputParamsPricings: {
          section: [
            // {
            //   start: '2019-01-22',
            //   end: '2019-01-25',
            //   time: ['2019-01-22', '2019-01-25'], // 需要把start和end合并到time数组
            //   price: '10',
            //   expectPrice: '100'
            // }
          ],
          outputParamsPricing: [
            // {
            //   pricing: [
            //     {
            //       type: '1',
            //       key: 'returnCode',
            //       value: '1',
            //       returnCode: '1' // 这个字段需拆分成上面的key value
            //     },
            //     {
            //       type: '5',
            //       key: 'serviceId',
            //       value: '4',
            //       serviceId: '4' // 这个字段需拆分成上面的key value
            //     }
            //   ]
            // }
          ]
        }
      },
      dataDetail: false, // 规则模板添加删除按钮 消失
      imgSrc: [],
      editable: false,
      detailDialog: false,
      modalClick: false,
      formLabelWidth: '120px',
      tableData: [],
      customerInfo: {
        afterUnitPrice: '',
        custName: '',
        beforeUnitPrice: '',
        adjustedStatus: '',
        custProdName: '',
        effectiveTime: '',
        createTime: '',
        custActName: '',
        modifier: '',
        strategyName: '',
        desc: ''
      },
      currentPage: 1,
      page: 10,
      total: 0
    }
  },
  filters: {
    adjustedStatusSwitch (state) {
      let type = parseInt(state)
      switch (type) {
        case 0:
          type = '已取消'
          break
        case 1:
          type = '待生效'
          break
        case 2:
          type = '生效中'
          break
        case 3:
          type = '已过期'
          break
        default:
          type = ''
      }
      return type
    }
  },
  components: {
    valuationTemplate1,
    valuationTemplate2,
    valuationTemplate3
  },
  methods: {
    onSubmit () {
      this.currentPage = 1
      this.page = 10
      this.query()
    },
    handleSizeChange (val) {
      this.page = val
      this.currentPage = 1
      this.query()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.query()
    },
    /* 重置操作 */
    onReset (formName) {
      this.$refs[formName].resetFields()
      this.form.custId = ''
      this.form.cusData = this.custCopeSimpleInfoList
      this.form.state = ''
      this.form.date = ''
    },
    clear (index, row) { // 取消
      this.$confirm('是否确认取消此次调价(提示：距离生效时间前15分钟不可取消)?', '取消调价', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let nowTime = new Date()
        let time = new Date(row.effectiveTime)
        if ((parseInt(time - nowTime) / 6000) <= 15) {
          this.$message.error('距离生效时间前15分钟不可取消')
          return
        }
        let op = {}
        op.custProdAdjustPriceId = row.custProdAdjustPriceId
        this.$axios({
          method: 'post',
          url: this.$API.customerManagement.cancelCustProdAdjustPrice,
          data: op
        }).then((response) => {
          if (response.data.resCode === 1) {
            this.$message.success('取消调价成功!')
            this.query()
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    /* 客户拼音搜索 */
    filterPinYinMethod (val) {
      const pinyinMatch = require('pinyin-match')
      if (val) {
        let result = []
        this.custCopeSimpleInfoList.forEach((v) => {
          let m = pinyinMatch.match(v.custName, val)
          if (m) {
            result.push(v)
          }
        })
        this.form.cusData = result
      } else {
        this.form.cusData = this.custCopeSimpleInfoList
      }
      this.form.custId = val
    },
    clearMatch () {
      this.form.cusData = this.custCopeSimpleInfoList
    },
    detail (index, row) {
      let _this = this
      this.customerInfo.afterUnitPrice = row.afterUnitPrice
      this.customerInfo.beforeUnitPrice = row.beforeUnitPrice
      this.customerInfo.custActName = row.custAccountName
      this.customerInfo.custProdName = row.serviceName
      this.customerInfo.strategyName = row.strategyName
      this.customerInfo.createTime = row.createTime
      this.customerInfo.effectiveTime = row.effectiveTime
      this.customerInfo.modifier = row.modifier
      this.customerInfo.desc = row.remark
      this.customerInfo.adjustedStatus = row.adjustedStatus
      this.customerInfo.custName = row.custName
      let getDetail = () => { // 请求详细信息
        return this.$axios({
          method: 'POST',
          url: _this.$API.customerManagement.queryCustProdAdjustPriceInfoByAdjustId,
          data: { custProdAdjustPriceId: row.custProdAdjustPriceId }
        })
      }
      let getRuleName = () => { // 请求计价规则对应字段
        return this.$axios({
          method: 'GET',
          url: _this.$API.product.queryInterfaceParamInfoByAll
        })
      }
      this.$axios.all([getDetail(), getRuleName()])
        .then(_this.$axios.spread(function (detail, strategy) {
          // 两个请求现在都执行完成
          if (detail.data.resData) {
            _this.imgSrc = detail.data.resData.certifications
            let data = JSON.parse(detail.data.resData.rule.ruleJson)
            if (detail.data.resData.rule.strategyId === '20171020110707_Yr2r1x61_1000002') { // 单次计价
              _this.single = true
              if (data.outputParamsPricings.length) {
                _this.ruleData.outputParamsPricings = [] // 每次重新请求清空数组
                for (let v of data.outputParamsPricings) {
                  let op = {}
                  op.outputParamsPricing = {}
                  op.outputParamsPricing.price = v.outputParamsPricing.price
                  op.outputParamsPricing.pricing = []
                  for (let i of v.outputParamsPricing.pricing) {
                    let ruleOp = {}
                    let key = Object.keys(i)[1]
                    ruleOp.type = i.type
                    ruleOp.value = i[key]
                    ruleOp.key = key
                    op.outputParamsPricing.pricing.push(ruleOp)
                  }
                  _this.ruleData.outputParamsPricings.push(op)
                  let newArr = _this.ruleData.outputParamsPricings.slice(0) // 克隆数组
                  _this.ruleData.outputParamsPricings = newArr // 整体重新赋值
                  // _this.ruleData = Object.assign({}, _this.ruleData)
                }
              }
            } else {
              _this.single = false
            }
            if (detail.data.resData.rule.strategyId === '20171020110707_Yr2r1x61_1000001' || detail.data.resData.rule.strategyId === '20171020110707_Yr2r1x61_1000000') { // 调用量阶梯收费/金额阶梯收费
              _this.amountDosage = true
              if (data.outputParamsPricings) {
                _this.amountData.outputParamsPricings.section = [] // 每次重新请求清空数组
                _this.amountData.outputParamsPricings.outputParamsPricing = [] // 每次重新请求清空数组
                console.log(data.outputParamsPricings)
                if (data.outputParamsPricings.section) {
                  _this.amountData.outputParamsPricings.section = data.outputParamsPricings.section
                }
                for (let v of data.outputParamsPricings.outputParamsPricing) {
                  let ruleAmountOp = {}
                  ruleAmountOp.pricing = []
                  for (let i of v.pricing) {
                    let keyOP = {}
                    let key = Object.keys(i)[1]
                    keyOP.key = key
                    keyOP.value = i[key]
                    keyOP.type = i.type
                    ruleAmountOp.pricing.push(keyOP)
                  }
                  _this.amountData.outputParamsPricings.outputParamsPricing.push(ruleAmountOp)
                }
              }
            } else {
              _this.amountDosage = false
            }
            if (detail.data.resData.rule.strategyId === '20171020110707_Yr2r1x61_1000003') { // 包时段阶梯收费
              _this.packetTime = true
              if (data.outputParamsPricings) {
                _this.packetData.outputParamsPricings.section = [] // 每次重新请求清空数组
                _this.packetData.outputParamsPricings.outputParamsPricing = [] // 每次重新请求清空数组
                console.log(data.outputParamsPricings)
                if (data.outputParamsPricings.section) {
                  // _this.packetData.outputParamsPricings.section = data.outputParamsPricings.section
                  for (let t of data.outputParamsPricings.section) {
                    let timeop = {}
                    timeop.price = t.price
                    timeop.expectPrice = t.expectPrice
                    timeop.time = []
                    timeop.time.push(t.start)
                    timeop.time.push(t.end)
                    _this.packetData.outputParamsPricings.section.push(timeop)
                  }
                }
                for (let v of data.outputParamsPricings.outputParamsPricing) {
                  let packetOp = {}
                  packetOp.pricing = []
                  for (let i of v.pricing) {
                    let keyOP = {}
                    let key = Object.keys(i)[1]
                    keyOP.key = key
                    keyOP.value = i[key]
                    keyOP.type = i.type
                    packetOp.pricing.push(keyOP)
                  }
                  _this.packetData.outputParamsPricings.outputParamsPricing.push(packetOp)
                  console.log(_this.packetData.outputParamsPricings)
                }
              }
            } else {
              _this.packetTime = false
            }
          }
        }))
      this.detailDialog = true
    },
    initData () {
      this.$axios({ // 请求客户名称
        url: this.$API.rechargeManagement.queryCustSimpleInfoList,
        method: 'post',
        data: {}
      }).then((response) => {
        if (!response.data.resData) return
        this.form.cusData = response.data.resData
        this.custCopeSimpleInfoList = response.data.resData
      }).catch((err) => {
        console.log(err)
      })
      this.query()
    },
    query () {
      let op = {}
      let _this = this
      op.pageNum = this.currentPage
      op.pageSize = this.page
      op.custId = this.form.custId
      op.adjustedStatus = this.form.status
      op.createTimeStart = this.form.date ? this.form.date[0] + ' 00:00:00' : ''
      op.createTimeEnd = this.form.date ? this.form.date[1] + ' 23:59:59' : ''
      this.$axios({
        url: _this.$API.customerManagement.queryCustProdAdjustPriceByPage,
        method: 'post',
        data: op
      }).then((response) => {
        console.log(response)
        _this.tableData = response.data.resData.resultList
        _this.total = response.data.resData.total
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  created () {
    this.initData()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/customerManagement/productAdjust.vue